var render, staticRenderFns
import script from "./SlideBar.vue?vue&type=script&lang=tsx&"
export * from "./SlideBar.vue?vue&type=script&lang=tsx&"
import style0 from "./SlideBar.vue?vue&type=style&index=0&id=b3fd11b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3fd11b8",
  null
  
)

export default component.exports